import { HandTracker } from './handLandmarker.jsx';

class App {
  constructor() {
    this.video = document.getElementById('webcam');
    this.canvas = document.getElementById('output_canvas');
    this.handTracker = new HandTracker();
    this.webcamRunning = false;
    this.styleButtons = {
      default: document.getElementById('defaultStyle'),
      neon: document.getElementById('neonStyle'),
      minimal: document.getElementById('minimalStyle')
    };

    this.initializeApp();
  }

  async initializeApp() {
    await this.handTracker.initialize();
    
    if (this.hasGetUserMedia()) {
      this.toggleWebcam();
      
      // Add style button listeners
      Object.entries(this.styleButtons).forEach(([style, button]) => {
        button.addEventListener('click', () => {
          this.handTracker.setVisualStyle(style);
          // Update active button state
          Object.values(this.styleButtons).forEach(btn => 
            btn.classList.remove('active')
          );
          button.classList.add('active');
        });
      });
    } else {
      console.warn("getUserMedia() is not supported by your browser");
      Object.values(this.styleButtons).forEach(button => 
        button.disabled = true
      );
    }
  }

  hasGetUserMedia() {
    return !!navigator.mediaDevices?.getUserMedia;
  }

  async toggleWebcam() {
    if (this.webcamRunning) {
      this.webcamRunning = false;
      // Stop all video streams
      this.video.srcObject.getTracks().forEach(track => track.stop());
      this.video.srcObject = null;
    } else {
      this.webcamRunning = true;
      
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: { ideal: 1280 },
            height: { ideal: 720 }
          }
        });
        
        this.video.srcObject = stream;
        this.video.addEventListener('loadeddata', () => this.predictWebcam());
      } catch (error) {
        console.error("Error accessing webcam:", error);
        this.webcamRunning = false;
        alert("Please allow camera access to use hand tracking!");
      }
    }
  }

  async predictWebcam() {
    // Update canvas dimensions to match video
    this.canvas.width = this.video.videoWidth;
    this.canvas.height = this.video.videoHeight;
    
    await this.handTracker.detectFrame(
      this.video,
      this.canvas,
      performance.now()
    );

    if (this.webcamRunning) {
      requestAnimationFrame(() => this.predictWebcam());
    }
  }
}

// Initialize the application
new App();